/**
 * Features the installed SSP Wallet advertises on `window.ssp.capabilities`.
 *
 * Released wallets (2.1.3 and older) have no `capabilities` and must be sent
 * exactly what they understand: their request sanitizer refuses any request
 * that carries an unknown non-string param (such as the vault descriptor
 * object), and they don't know `enterprise_vault_address`.
 */
export const WALLET_CAPABILITY = {
  /** Enterprise vault requests carry, and are checked against, a vaultDescriptor. */
  vaultDescriptor: 'vault_descriptor_v1',
  /** The `enterprise_vault_address` method (show a vault address on the wallet). */
  vaultAddress: 'enterprise_vault_address',
} as const;

export type WalletCapability = (typeof WALLET_CAPABILITY)[keyof typeof WALLET_CAPABILITY];

export function walletHasCapability(
  capability: WalletCapability,
  provider: unknown = typeof window !== 'undefined' ? window.ssp : undefined
): boolean {
  const capabilities = (provider as { capabilities?: unknown } | undefined)?.capabilities;
  return Array.isArray(capabilities) && capabilities.includes(capability);
}
